import * as React from "react";

function StarRating(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_123_19748)">
        <path
          d="M12.4655 17.9953C12.174 17.8417 11.8256 17.8416 11.5339 17.9949L7.6214 20.052C6.88776 20.4377 6.0303 19.8147 6.17043 18.9978L6.91787 14.6406C6.97356 14.3159 6.86581 13.9847 6.62978 13.7549L3.46073 10.6702C2.86646 10.0917 3.19406 9.08289 4.01481 8.96394L8.3863 8.33039C8.71216 8.28317 8.99389 8.07856 9.13961 7.78329L11.0961 3.81897C11.4629 3.07571 12.5228 3.07571 12.8896 3.81897L14.8461 7.78329C14.9918 8.07856 15.2735 8.28317 15.5994 8.33039L19.9709 8.96394C20.7916 9.08289 21.1192 10.0917 20.5249 10.6702L17.3559 13.7549C17.1199 13.9847 17.0121 14.3159 17.0678 14.6406L17.8148 18.9954C17.955 19.8128 17.0967 20.4358 16.363 20.0492L12.4655 17.9953Z"
          stroke="#E7212B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_19748">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default StarRating;
